class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    
    // For cart-icon-bubble, extract ONLY the cart count bubble and hidden text
    if (selector && selector.includes('cart-icon-bubble')) {
      // Get the cart-icon-bubble element
      const cartIconBubble = parsedHtml.querySelector('#cart-icon-bubble');
      
      let result = '';
      
      if (cartIconBubble) {
        // Remove any SVG wrapper or icon elements first
        const svgWrappers = cartIconBubble.querySelectorAll('.svg-wrapper, .icon-cart, svg, [class*="icon"]');
        svgWrappers.forEach(svg => svg.remove());
        
        // Now get the count bubble and hidden text
        const countBubble = cartIconBubble.querySelector('.cart-count-bubble');
        let hiddenText = cartIconBubble.querySelector('.visually-hidden');
        
        // If no hidden text in cart-icon-bubble, look for it elsewhere
        if (!hiddenText) {
          hiddenText = parsedHtml.querySelector('.visually-hidden');
        }
        
        if (countBubble) {
          result += countBubble.outerHTML;
        }
        if (hiddenText) {
          result += hiddenText.outerHTML;
        }
      } else {
        // Fallback: look for count bubble and hidden text directly
        const countBubble = parsedHtml.querySelector('.cart-count-bubble');
        const hiddenText = parsedHtml.querySelector('.visually-hidden');
        
        if (countBubble) {
          result += countBubble.outerHTML;
        }
        if (hiddenText) {
          result += hiddenText.outerHTML;
        }
      }
      
      return result;
    }
    
    // Default behavior for other sections
    return parsedHtml.querySelector(selector)?.innerHTML || '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);